import { render, staticRenderFns } from "./ChangePECPassword.vue?vue&type=template&id=4753c70f&"
import script from "./ChangePECPassword.vue?vue&type=script&lang=js&"
export * from "./ChangePECPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports